import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const divider = css`
  opacity: 0.4;
`

export const lineSlotMarginDivider = css`
  margin: ${spacing(0, 1, 0, 6)};
`
